import SrSubTitle from "./index.vue";

SrSubTitle.install = function(Vue) {
  Vue.component(SrSubTitle.name, SrSubTitle);
};

export default SrSubTitle;


// WEBPACK FOOTER //
// ./packages/SrSubTitle/index.js